import $ from 'jquery';
import whenDomReady from 'when-dom-ready';

import '../../styles/pages/quiz.scss';

whenDomReady(() => {
    
});